/* Cookie-Einstellungen per Link öffnen (Shopify Cookie-Banner) */
document.addEventListener('click', function (e) {
  var link = e.target.closest('a[href*="cookie-einstellungen"]');
  if (!link) return;
  e.preventDefault();
  if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
    window.privacyBanner.showPreferences();
  }
});